export const regPattern = 'Reaction-ID:(\\d+)-Steps:([\\d;]+)';

export const parseSchemeString = (schemeString) => {
  const reg = new RegExp(regPattern, 'ig');
  const matched = reg.exec(schemeString);

  return {
    rootReactionId: matched && matched[1],
    stepReactionIds: matched && matched[2] && matched[2].split(';') || [],
  }
}
